/**
 * A shared mailbox (info@, support@) is its own owner: neither a person nor the
 * whole organisation. Its connection, synced mail and Inbox items carry this
 * owner id in user_id, so no existing "mine or the organisation's" reader sees
 * it; admins and Data Role grantees read it explicitly.
 */
export const SHARED_MAILBOX_OWNER_PREFIX = "mailbox_";
export function isSharedMailboxOwner(userId) {
    return typeof userId === "string" && userId.startsWith(SHARED_MAILBOX_OWNER_PREFIX);
}
/** A shared mailbox syncs Gmail messages and nothing else. */
export const SHARED_MAILBOX_GMAIL_ENTITIES = ["message"];
export function isSharedMailboxInstance(provider, connectorKind) {
    return provider === "gmail" && connectorKind === "shared_mailbox";
}
